/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pb_Community_OffInputs */

const en_pb_community_off = /** @type {(inputs: Pb_Community_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Community playbooks from GitHub could not be loaded right now — only Bystep’s own are shown.`)
};

const id_pb_community_off = /** @type {(inputs: Pb_Community_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Playbook komunitas dari GitHub sedang tidak bisa dimuat — hanya milik Bystep yang ditampilkan.`)
};

/**
* | output |
* | --- |
* | "Community playbooks from GitHub could not be loaded right now — only Bystep’s own are shown." |
*
* @param {Pb_Community_OffInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const pb_community_off = /** @type {((inputs?: Pb_Community_OffInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pb_Community_OffInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_pb_community_off(inputs)
	return en_pb_community_off(inputs)
});